



































































































































































































import { defineComponent, onMounted, ref } from '@vue/composition-api'
import { AppFieldDTO, AppFieldGroupDTO } from '@/api/types-app'
import { addAppField, getAllAppFields, addOrRemoveRelatedFields, addOrRemoveChildrenGroup } from '@/api/admin'
import store from '../../store'
import { JSONEditor } from 'vanilla-jsoneditor'

export default defineComponent({
  name: 'AppField',
  props: {
    _appField: {
      type: Object as () => AppFieldDTO,
      required: false
    },
    fields: {
      type: Array as () => Array<AppFieldDTO>,
      required: false
    }
  },
  setup(props) {
    const appField = ref<AppFieldDTO>({
      appFieldId: null,
      appFieldName: null,
      displayName: null,
      displayNamePDR: null,
      displayNameFannieMae: null,
      selectedvalue: null,
      associatedOrderField: null,
      fieldId: null,
      description: null,
      helpDescription: null,
      valueTypeName: null,
      valueType: {
        valueTypeId: null,
        type: null,
        name: null,
        description: null
      },
      fieldTypeName: null,
      fieldType: {
        fieldTypeId: null,
        fieldTypeName: null,
        displayName: null,
        description: null
      },
      appWidget: {
        appWidgetId: null,
        appFieldId: null,
        heading: null,
        description: null,
        attributes: null
      },
      selectItemList: {
        selectItemListId: null,
        selectItemListName: null,
        key: null,
        selectItems: []
      },
      defaultvalue: null,
      truthyvalue: null,
      truthyvalueComparisonOperator: null,
      ordervalue: null,
      selectItems: null,
      validationRules: null,
      sortOrder: null,
      pageNumber: null,
      relatedFields: null,
      compositeAppFields: null,
      childrenGroup: null
    })

    const appFields = ref<Array<AppFieldDTO>>(null)
    const appFieldSelection = ref<Array<AppFieldDTO>>([])

    if (props.fields) {
      appFields.value = props.fields
    } else {
      const request = getAllAppFields()
      request.then((response) => {
        console.log('here')
        response.data.forEach((elem: any) => {
          elem.label = elem.appFieldName
          elem.value = elem.appFieldId
        })
        appFields.value = response.data
      })
    }

    const editMode = !!props._appField
    appField.value = editMode ? props._appField : appField.value

    const handleAdd = async() => {
      appField.value.validationRules = JSON.stringify(JSON.stringify(appField.value.validationRules as string))

      try {
        await addAppField(appField.value)
        appField.value.relatedFields = appField.value.relatedFields.filter(rf => rf.new || rf.delete)
        appField.value.childrenGroup = (appField.value.childrenGroup as Array<AppFieldDTO>).filter((cg: AppFieldDTO) => cg.new || cg.delete)
        if (editMode && appField.value.relatedFields.length > 0) await addOrRemoveRelatedFields(appField.value)
        if (editMode && appField.value.childrenGroup.length > 0) await addOrRemoveChildrenGroup(appField.value)
        // eslint-disable-next-line no-self-assign
        window.location.href = window.location.href
      } catch {
        alert('Something went wrong')
      }
    }

    const handleSelectItemList = (selectItemListName: string) => {
      appField.value.selectItemList = store.state.app.selectItemList.find(elem => elem.selectItemListName === selectItemListName)
    }

    const handleFieldType = (fieldTypeName: string) => {
      appField.value.fieldType = store.state.app.fieldTypeList.find(elem => elem.fieldTypeName === fieldTypeName)
    }

    const handleValueType = (valueTypeName: string | number) => {
      appField.value.valueType = store.state.app.valueTypeList.find(elem => elem.name === valueTypeName)
    }

    const removeRelatedField = (field) => {
      console.log(field)
    }

    const removeChildField = (field) => {
      console.log(field)
    }

    onMounted(() => {
      let content = {
        json: appField.value.validationRules
      }

      const editor = new JSONEditor({
        target: document.getElementById('jsoneditor'),
        props: {
          content,
          onChange: (updatedContent, previousContent, { contentErrors, patchResult }) => {
            // console.log('onChange', { updatedContent, previousContent, contentErrors, patchResult })
            if (contentErrors.validationErrors && contentErrors.validationErrors.length === 0) {
              console.log(updatedContent.text)
              content = JSON.parse(updatedContent.text)
              appField.value.validationRules = JSON.parse(updatedContent.text)
            }
          }
        }
      })
    })

    return { appField, appFields, editMode, handleAdd, handleSelectItemList, appFieldSelection, handleFieldType, handleValueType, removeRelatedField, removeChildField }
  }
})
